import React, { createContext, useContext, useState } from 'react';

const ConfigContext = createContext();

export function useConfig() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
}

export function ConfigProvider({ children }) {
  // Static config for now - API endpoint will be added later
  const [config] = useState({
    brand_name: 'Cleona',
    brand_logo: null,
    primary_color: '#4F46E5',
    secondary_color: '#6366F1',
    max_documents: 100,
    max_queries_per_day: 1000,
    max_file_size_mb: 50
  });
  const [loading] = useState(false);

  const fetchConfig = async () => {
    // TODO: Enable when /api/config endpoint is available
    // try {
    //   const response = await configAPI.getConfig();
    //   setConfig(response);
    // } catch (error) {
    //   console.error('Failed to fetch config:', error);
    // }
  };

  const value = {
    config,
    loading,
    refreshConfig: fetchConfig
  };

  return (
    <ConfigContext.Provider value={value}>
      {children}
    </ConfigContext.Provider>
  );
}
